import React, { forwardRef } from 'react';
import { ScrollView as rScrollView } from 'react-native';
import { useSx } from '../use-sx';
import { styled } from '../css/styled';
const DripsyScrollView = styled(rScrollView)();
export const ScrollView = forwardRef(function ScrollView(props, ref) {
    const sx = useSx();
    const containerSx = props.contentContainerSx && sx(props.contentContainerSx);
    const indicatorSx = props.indicatorSx && sx(props.indicatorSx);
    return (<DripsyScrollView {...props} contentContainerStyle={props.contentContainerStyle && containerSx
            ? [props.contentContainerStyle, containerSx]
            : containerSx || props.contentContainerStyle} indicatorStyle={props.indicatorStyle && indicatorSx
            ? [props.indicatorStyle, indicatorSx]
            : indicatorSx || props.indicatorStyle} ref={ref}/>);
});
//# sourceMappingURL=ScrollView.js.map